import { DollarSign } from "react-feather";
import ShoppingIcon from "../../Components/Common/svg/shoppingicon";
import ShippingIcon from "../../Components/Common/svg/Shippingicon";
import StoreIcon from "../../Components/Common/svg/storeicon";
import RefreshIcon from "../../Components/Common/svg/reports/refreshicon";
import MoneyBagIcon from "../../Components/Common/svg/reports/moneybagicon";
import { formatPrice } from "../../utils/formatPrice";
import UsersIcon from "../../Components/Common/svg/usersIcon";
import AddclientIcon from "../../Components/Common/svg/reports/addclienticon";
import StatsStar from "../../Components/Common/svg/statsstar";

export const tabs = [
  { id: 3, label: "تقرير المبيعات", key: "sales" ,permission:"view_report"},
  { id: 4, label: "تقرير الطلبات", key: "orders" ,permission:"view_report"},
  { id: 5, label: "تقرير العملاء", key: "clients" ,permission:"view_report"},
  { id: 6, label: "تقرير المتاجر", key: "stores" ,permission:"view_report"},
  { id: 2, label: "تقرير التوصيل", key: "delivery" ,permission:"view_report"},
];



export const salesStatusConfig = (statsWidget) => [
  {
    title: "مجموع الطلبات",
    count: statsWidget?.order_widget?.totalOrders	,
    color: "#FFCC03",
    icon: <ShoppingIcon color="#FFCC03" />,
    bgIcon: "#E6F3EF",
    type: statsWidget?.order_widget?.periodTrend,
    rate: statsWidget?.order_widget?.periodRate,
  },
  {
    title: "مجموع المبيعات",   
    count:  formatPrice( statsWidget?.currency_factor   , statsWidget?.sales_widget?.totalSales) ,   
    color: "#3F5568",
    icon: <DollarSign />,
    bgIcon: "#E7EAEC",
    type: statsWidget?.sales_widget?.periodTrend,
    rate: statsWidget?.sales_widget?.periodRate,
  },

  {
    title: "المبالغ المستردة",
    count:  formatPrice( statsWidget?.currency_factor, statsWidget?.refunds_widget?.totalRefunds),
    color: "#FF3B30",
    icon: <RefreshIcon  />,
    bgIcon: "#FDEAE9",
    type: statsWidget?.refunds_widget?.periodTrend,
    rate: statsWidget?.refunds_widget?.periodRate,
  },

    {
    title: "العمولة المكتسبة",
    count: statsWidget?.commission_widget?.totalCommission,
    color: "#0F2B42",
    icon: <MoneyBagIcon />,
    bgIcon: "#E7EAEC",
    type: statsWidget?.commission_widget?.periodTrend,
    rate: statsWidget?.commission_widget?.periodRate,
  },  
];




export const oredersStatusConfig = (statsWidget) => [
  {
    title: "إجمالي الطلبات",
    count:statsWidget?.order_widget?.totalOrders	,
    color: "#FFCC03",
    icon: <ShoppingIcon color="#FFCC03" />,
    bgIcon: "#E6F3EF",

  },
  {
    title: "الطلبات المُسلّمة",
    count: statsWidget?.metrics?.delivered_orders ,
    color: "#3F5568",
    icon: <DollarSign />,
    bgIcon: "#E7EAEC",
   
  },

  {
    title: "الطلبات الملغاة",
    count: statsWidget?.metrics?.cancelled_orders,
    color: "#FF3B30",
    icon: <RefreshIcon  />,
    bgIcon: "#FDEAE9",
   
  },

    {
    title: "الطلبات المُعادة",
    count: statsWidget?.metrics?.returned_orders,
    color: "#0F2B42",
    icon: <MoneyBagIcon />,
    bgIcon: "#E7EAEC",
  
  },  
      {
    title: "متوسط ​​وقت التوصيل",
    count: statsWidget?.metrics?.average_delivery_time,
    color: "#0F2B42",
    icon: <MoneyBagIcon />,
    bgIcon: "#E7EAEC",

  }, 
];



export const clientsStatusConfig = (statsWidget) => [
  {
    title: "مجموع العملاء",  
    count:statsWidget?.customer_analytics?.total_customers	,
    color: "#FFCC03",
    icon: <UsersIcon/>,
    bgIcon: "#F0FDF9",

  },
  {
    title: "العملاء الجدد",
    count: statsWidget?.customer_analytics?.new_customers ,
    color: "#3F5568",
    icon: <AddclientIcon />,
    bgIcon: "#E7EAEC",
   
  },

  {
    title: "العملاء العائدين",
    count: statsWidget?.customer_analytics?.returning_customers,
    color: "#FF3B30",
    icon: <RefreshIcon  />,
    bgIcon: "#FDEAE9",
   
  },

    {
    title: "إجمالي الإيرادات",
    count: statsWidget?.metrics?.returned_orders,
    color: "#0F2B42",
    icon: <MoneyBagIcon />,
    bgIcon: "#E7EAEC",
  
  },  
 
];


export const storesStatusConfig = (statsWidget) => [
  {
    title: "مجموع المتاجر",  
    count:statsWidget?.customer_analytics?.total_customers	,
    color: "#FFCC03",
    icon: <StoreIcon/>,
    bgIcon: "#F0FDF9",

  },
  {
    title: "مجموع المبيعات",
    count: statsWidget?.customer_analytics?.new_customers ,
    color: "#003726",
    icon: <DollarSign />,
    bgIcon: "#8AC6B4",
   
  },

  {
    title: "مجموع الطلبات",
    count: statsWidget?.customer_analytics?.returning_customers,
    color: "#616161",
    icon: <ShoppingIcon  />,
    bgIcon: "#F7F7F7",
   
  },

    {
    title: "متوسط ​​التقييم",
    count: statsWidget?.metrics?.returned_orders,
    color: "#FC0",
    icon: <StatsStar />,
    bgIcon: "#FFFCE9",
  
  },  
     {
    title: "العمولة المكتسبة",
    count: statsWidget?.metrics?.returned_orders,
    color: "#0F2B42",
    icon: <MoneyBagIcon />,
    bgIcon: "#E7EAEC",
  
  },  
 
];

export const deliveryStatsConfig =(statsWidget)=>[
    {
    title: "عدد الشركات",  
    count:statsWidget?.customer_analytics?.total_customers	,
    color: "#FFCC03",
    icon: <StoreIcon/>,
    bgIcon: "#F0FDF9",

  },
  {
    title: "الإيرادات",
    count: statsWidget?.customer_analytics?.new_customers ,
    color: "#003726",
    icon: <DollarSign />,
    bgIcon: "#8AC6B4",
   
  },

  {
    title: "الطلبات اليوم",
    count: statsWidget?.customer_analytics?.returning_customers,
    color: "#616161",
    icon: <ShoppingIcon  />,
    bgIcon: "#F7F7F7",
   
  },

    {
    title: "التسليم في الوقت",
    count: statsWidget?.metrics?.returned_orders,
    color: "#FC0",
    icon: <StatsStar />,
    bgIcon: "#FFFCE9",
  
  },  
     {
    title: "الطلبات الملغاة",
    count: statsWidget?.metrics?.returned_orders,
    color: "#FF3B30",
    icon: <MoneyBagIcon />,
    bgIcon: "#FDEAE9",
  
  },
]